/**
 * MEMOLINK data model (schema v2).
 *
 * Records are stored flat with a parent id and a position, instead of nested arrays,
 * so each record can later be synced to a cloud table on its own.
 * IDs are created once and never change: Workspace > Category > Action.
 */
export type Id = string;
export type IsoDate = string;

export type ActionType = "link" | "memo";
export type OpenWith = "default" | "chrome" | "safari" | "app";

interface Base {
  id: Id;
  name: string;
  icon: string;
  position: number;
  /** true only for records created by the sample data set */
  sample?: boolean;
  createdAt: IsoDate;
  updatedAt: IsoDate;
}

export interface Workspace extends Base {}

export interface Category extends Base {
  workspaceId: Id;
  /** colour key of the glow under the key frame */
  glow: string;
}

export interface Action extends Base {
  categoryId: Id;
  type: ActionType;
  /** icon colour, chosen separately from the category glow */
  color: string;
  url: string;
  text: string;
}

export interface Settings {
  activeWorkspaceId: Id | null;
  openWith: OpenWith;
}

export interface Library {
  workspaces: Workspace[];
  categories: Category[];
  actions: Action[];
  settings: Settings;
}

export type EntityKind = "workspace" | "category" | "action";

export const SCHEMA_VERSION = 2;
export const OPEN_WITH: readonly OpenWith[] = ["default", "chrome", "safari", "app"];

export const emptyLibrary = (): Library => ({
  workspaces: [], categories: [], actions: [],
  settings: { activeWorkspaceId: null, openWith: "default" }
});
